import React, { useState } from 'react';
import appStyle from "./AIAgentBot.module.css";
import RazorpayCheckout from '../RazorpayCheckout';

export default function AIMessageCredits({ limit, remaining, totalTopups, isLoading }) {
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState(1500);
  const [topUpMessages, setTopUpMessages] = useState(750);

  const totalCapacity = limit + totalTopups;
  const remainingPercentage = totalCapacity > 0 ? (remaining / totalCapacity) * 100 : 0;
  
  const isLow = () => {
    if (totalCapacity === 0) return false;
    return remainingPercentage < 20;
  };
  
  const hasTopups = totalTopups > 0;

  const handleTopUp = () => {
    setShowTopUpModal(true);
  };

  return (
    <>
      <div className={appStyle.creditSection}>
        <h3>🔋 AI Message Credits</h3>
        {isLoading ? (
          <div className={appStyle.loadingState}>
            <span className={appStyle.loadingSpinner}></span>
            <p>Loading credits...</p>
          </div>
        ) : (
          <div className={appStyle.creditsContainer}>
            <div className={appStyle.creditsMain}>
              <span className={appStyle.creditsRemaining}>
                {remaining.toLocaleString()}
              </span>
              <span className={appStyle.creditsLabel}>
                Available Credits
              </span>
            </div>

            <div className={appStyle.progressBar}>
              <div
                className={appStyle.progressFill}
                style={{ width: `${remainingPercentage}%` }}
              />
            </div>

            <div className={appStyle.capacityInfo}>
              <div className={appStyle.capacityRow}>
                <span>📋 Plan Limit:</span>
                <strong>{limit.toLocaleString()} messages</strong>
              </div>
              {hasTopups && (
                <div className={appStyle.capacityRow}>
                  <span>➕ Top-ups Added:</span>
                  <strong className={appStyle.topupHighlight}>+{totalTopups.toLocaleString()} messages</strong>
                </div>
              )}
              <div className={appStyle.capacityRow}>
                <span>🎯 Total Capacity:</span>
                <strong>{totalCapacity.toLocaleString()} messages</strong>
              </div>
            </div>

            <div className={appStyle.statsNote}>
              💡 <strong>How it works:</strong> This shows your currently available message credits. Each AI message uses 1 credit. When you run low, top up to add more capacity beyond your plan limit.
            </div>

            {isLow() && (
              <div className={appStyle.topUpSection}>
                <button onClick={handleTopUp} className={appStyle.topUpButton}>
                  🔋 Top Up AI Messages
                </button>
                <div className={appStyle.topUpInfo}>
                  Get 750 more AI messages for ₹1500 (~₹2 per message)
                </div>
              </div>
            )}

            {remainingPercentage < 10 && remaining > 0 && (
              <div className={appStyle.lowCreditsWarning}>
                ⚠️ Running low on AI messages! Only {remaining.toLocaleString()} credits remaining ({Math.round(remainingPercentage)}% left). Top up now to avoid interruption.
              </div>
            )}

            {remaining <= 0 && (
              <div className={appStyle.criticalWarning}>
                🚨 Out of AI messages! Please top up immediately to restore service.
              </div>
            )}
          </div>
        )}
      </div>

      {showTopUpModal && (
        <div className={appStyle.modalOverlay} onClick={() => setShowTopUpModal(false)}>
          <div className={appStyle.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={appStyle.modalHeader}>
              <h3>🔋 Top Up AI Messages</h3>
              <button className={appStyle.modalClose} onClick={() => setShowTopUpModal(false)}>✕</button>
            </div>
            <div className={appStyle.modalBody}>
              <div className={appStyle.infoNote}>
                <strong>Current Capacity:</strong> {remaining.toLocaleString()} credits available<br />
                <strong>After Top-up:</strong> {remaining + topUpMessages} credits available<br />
                <strong>Total Capacity:</strong> {totalCapacity + topUpMessages} messages (Plan: {limit} + Top-ups: {totalTopups + topUpMessages})
              </div>
              <div className={appStyle.topUpOptions}>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹1500</div>
                  <div className={appStyle.optionMessages}>+750 AI Messages</div>
                  <div className={appStyle.optionPerMessage}>~₹2 per message</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(1500); setTopUpMessages(750); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹3000</div>
                  <div className={appStyle.optionMessages}>+1500 AI Messages</div>
                  <div className={appStyle.optionPerMessage}>~₹2 per message</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(3000); setTopUpMessages(1500); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹4500</div>
                  <div className={appStyle.optionMessages}>+2250 AI Messages</div>
                  <div className={appStyle.optionPerMessage}>~₹2 per message</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(4500); setTopUpMessages(2250); }}>Select</button>
                </div>
              </div>
              <div className={appStyle.checkoutContainer}>
                <RazorpayCheckout cost={topUpAmount} planName={`Top Up - ${topUpMessages} AI Messages`} planCode="TOPUP" userLimit={null} appliedPromo={null} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}